// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3meAB","itemTitle":"ClientEmergencyInfo_itemTitle__3zdEg","itemText":"ClientEmergencyInfo_itemText__3ZoUe"};